import { enhancedApi } from './generated/portalProvidersService';

const portalProviderApi = enhancedApi.enhanceEndpoints({});

export const { useTreatmentPortalsProvidersListQuery } = portalProviderApi;
